import React, { useState } from 'react';
import { FiHeart, FiCreditCard, FiInfo, FiMail, FiArrowRight, FiUsers, FiExternalLink, FiCopy, FiCheck } from 'react-icons/fi';
import '../styles/about.css';
import '../styles/support.css';

const SupportPage = () => {
  const IBAN = 'EE08 7700 7710 1239 4583';
  const bankName = 'LHV Pank';
  const recipient = 'MTÜ Electrospinning-Data Organization';
  const registryUrl = 'https://ariregister.rik.ee/eng/company/80663944/MTÜ-Electrospinning-Data-Organization';

  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(IBAN.replace(/\s/g, '')).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="about-bento-container py-5">
      <header className="text-center mb-5 bento-header">
        <h1 className="display-4 font-weight-bold">Support the Platform</h1>
        <p className="lead text-muted about-intro-bento">
          Help sustain Electrospinning Data — your support keeps the platform running, funds dataset curation,
          and enables development of new tools for the community.
        </p>
      </header>

      <div className="bento-grid-about">

        {/* 1. Why support — wide left, blue CTA style */}
        <div className="bento-tile tile-cta support-why-tile">
          <div className="tile-icon-bg"><FiHeart /></div>
          <div className="tile-content">
            <span className="tile-label text-white-50 mb-2 d-block">Why support</span>
            <h2 className="tile-title-sm text-white">Support open research</h2>
            <p className="tile-desc mt-2 text-white-50">
              Your contribution helps keep the platform available and improves the quality and reach of openly shared
              electrospinning datasets. Funds are used for servers, software maintenance, data curation, and outreach.
            </p>
          </div>
        </div>

        {/* 2. Legal entity — narrow right, dark style */}
        <div className="bento-tile tile-who">
          <div className="tile-icon-bg"><FiExternalLink /></div>
          <div className="tile-content text-white">
            <span className="tile-label text-white-50 mb-2 d-block">Legal entity</span>
            <h3 className="tile-title-sm text-white">MTÜ Electrospinning-Data Organization</h3>
            <p className="tile-desc-sm text-white-50 mt-2">
              A registered Estonian non-profit (<em>mittetulundusühing</em>), registry code <strong className="text-white">80663944</strong>.
            </p>
            <a
              href={registryUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="bento-btn bento-btn-accent mt-auto"
            >
              Business Register <FiExternalLink className="ms-2" />
            </a>
          </div>
        </div>

        {/* 3. Bank transfer details — spans 2 cols */}
        <div className="bento-tile tile-why">
          <div className="tile-icon-bg"><FiCreditCard /></div>
          <div className="tile-content">
            <span className="tile-label mb-2 d-block">How to support</span>
            <h3 className="tile-title-sm">Bank transfer details</h3>
            <p className="tile-desc-sm mt-2">
              Use the bank details below. For a receipt or invoice, contact us after the transfer.
            </p>
            <div className="support-iban-box mt-3">
              <div className="iban-row">
                <span className="iban-label">Recipient</span>
                <span className="iban-value">{recipient}</span>
              </div>
              <div className="iban-row">
                <span className="iban-label">Bank</span>
                <span className="iban-value">{bankName}</span>
              </div>
              <div className="iban-row">
                <span className="iban-label">IBAN</span>
                <span className="iban-value-row">
                  <span className="iban-highlight">{IBAN}</span>
                  <button
                    className={`iban-copy-btn ${copied ? 'iban-copy-btn--copied' : ''}`}
                    onClick={handleCopy}
                    title={copied ? 'Copied!' : 'Copy IBAN'}
                  >
                    {copied ? <FiCheck size={13} /> : <FiCopy size={13} />}
                    {copied ? 'Copied' : 'Copy'}
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* 4. Contact — narrow, dark */}
        <div className="bento-tile support-contact-tile">
          <div className="tile-icon-bg"><FiMail /></div>
          <div className="tile-content">
            <span className="tile-label mb-2 d-block">Need help?</span>
            <h3 className="tile-title-sm">Contact us</h3>
            <p className="tile-desc-sm mt-2">
              Need a receipt, an invoice, or prefer a different payment method? Reach out to the support team.
            </p>
            <a href="/contact" className="bento-btn bento-btn-accent mt-auto">
              Contact Support <FiArrowRight className="ms-2" />
            </a>
          </div>
        </div>

        {/* 5. Transparency — full width */}
        <div className="bento-tile tile-features">
          <div className="tile-content w-100">
            <span className="tile-label mb-3 d-block">Transparency &amp; use of funds</span>
            <div className="features-inner-grid">
              <div className="feature-block">
                <div className="feature-icon"><FiInfo /></div>
                <div>
                  <h4 className="feature-heading">Use of funds</h4>
                  <p className="feature-text">Hosting, development, dataset curation, and community outreach.</p>
                </div>
              </div>
              <div className="feature-block">
                <div className="feature-icon"><FiMail /></div>
                <div>
                  <h4 className="feature-heading">Reporting</h4>
                  <p className="feature-text">Periodic brief reports will be published describing fund allocation.</p>
                </div>
              </div>
              <div className="feature-block">
                <div className="feature-icon"><FiUsers /></div>
                <div>
                  <h4 className="feature-heading">Community-focused</h4>
                  <p className="feature-text">We prioritise open access and community benefits when allocating funds.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default SupportPage;

